module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_co_cats_nursing_care_equipment_efce0c818ca46e33c60a22092a68a43d.png";